import {
    useShareRequest as sdsgUseShareRequest,
    useUpdateRequest as sdsgUseUpdateRequest,
    useAssignRequest as sdsgUseAssignRequest,
    useCreateRequest as sdsgUseCreateRequest,
    usePostAddCustomer as sdsgUsePostAddCustomer,
    useAddAttachment as sdsgUseAddAttachment,
    useRemoveAttachment as sdsgUseRemoveAttachment,
    useUpdateAttachmentClassification as sdsgUseUpdateAttachmentClassification,
    useRemoveCustomerImpact as sdsgUseRemoveCustomerImpact,
    usePostCommentsHashTags as sdsgUsePostCommentsHashTags
} from './sdsg-api';
import {
    useShareRequest as cxpUseShareRequest,
    useUpdateRequest as cxpUseUpdateRequest,
    useAssignRequest as cxpUseAssignRequest,
    useCreateRequest as cxpUseCreateRequest,
    usePostAddCustomer as cxpUsePostAddCustomer,
    useAddAttachment as cxpUseAddAttachment,
    useRemoveAttachment as cxpUseRemoveAttachment,
    useUpdateAttachmentClassification as cxpUseUpdateAttachmentClassification,
    useRemoveCustomerImpact as cxpUseRemoveCustomerImpact,
    usePostCommentsHashTags as cxpUsePostCommentsHashTags
} from './cxp-api';
import {
    useShareRequest as cssUseShareRequest,
    useUpdateRequest as cssUseUpdateRequest,
    useAssignRequest as cssUseAssignRequest,
    useCreateRequest as cssUseCreateRequest,
    usePostAddCustomer as cssUsePostAddCustomer,
    useAddAttachment as cssUseAddAttachment,
    useRemoveAttachment as cssUseRemoveAttachment,
    useUpdateAttachmentClassification as cssUseUpdateAttachmentClassification,
    useRemoveCustomerImpact as cssUseRemoveCustomerImpact,
    usePostCommentsHashTags as cssUsePostCommentsHashTags
} from './css-api';
import {
    useShareRequest as crewUseShareRequest,
    useUpdateRequest as crewUseUpdateRequest,
    useAssignRequest as crewUseAssignRequest,
    useCreateRequest as crewUseCreateRequest,
    usePostAddCustomer as crewUsePostAddCustomer,
    useAddAttachment as crewUseAddAttachment,
    useRemoveAttachment as crewUseRemoveAttachment,
    useUpdateAttachmentClassification as crewUseUpdateAttachmentClassification,
    useRemoveCustomerImpact as crewUseRemoveCustomerImpact,
    usePostCommentsHashTags as crewUsePostCommentsHashTags
} from './crew-api';
import {
    IAddAttachmentDto,
    IAddCustomerImpactDto,
    IAssignRequestDto,
    ICreatePostSalesDto,
    ICreatePreSalesDto,
    ICustomerImpactDto,
    IHashTagDto,
    IUpdateClassificationDto,
    RequestType
} from 'generated/crew-backend';
import {
    IAttachmentRequest,
    IShareRequest
} from 'app/models/common/request';
import { appInsightsService, RouteConstants, StringConstants } from 'app/utils/constants';
import { useMutation } from 'react-query';
import { AppQueryClient } from './clients/query-client';
import { ICreateProposalDto, ICreateQuestionDto, ICreateRfxDto } from 'generated/sdsg-backend';
import { ICreateIrtDto } from 'generated/cxp-backend';
import { ICreateCssReviewRequestDto, ICssRequestDto } from 'generated/css-backend';
import { IUpdateRequestDto } from 'generated/request-backend';

export interface IHelpService {
    subUrl: string;
    data: ICreateProposalDto | ICreateQuestionDto | ICreateRfxDto | ICreateIrtDto | ICssRequestDto | ICreateCssReviewRequestDto | ICreatePreSalesDto | ICreatePostSalesDto;
}

export const usePostRequestType = () => {
    const requestTypeMutation = useMutation(
        (params: IHelpService) => {
            switch (params.subUrl) {
                case RouteConstants.SDSG_PROPOSAL:
                    return sdsgUseCreateRequest(RequestType.Proposal, params.data); 
                case RouteConstants.SDSG_QUESTION:
                    return sdsgUseCreateRequest(RequestType.Question, params.data); 
                case RouteConstants.SDSG_RFX:
                    return sdsgUseCreateRequest(RequestType.Rfx, params.data); 
                case RouteConstants.CREW_PRESALES:
                    return crewUseCreateRequest(RequestType.PreSales, params.data);
                case RouteConstants.CREW_POSTSALES:
                    return crewUseCreateRequest(RequestType.PostSales, params.data);
                case RouteConstants.SUB_CSS_REQUEST:
                    return cssUseCreateRequest(RequestType.CSSRequest, params.data);
                case RouteConstants.CSS_REVIEW_REQUEST:
                    return cssUseCreateRequest(RequestType.CssReviewRequest, params.data);
                case RouteConstants.CXP_IRT_REQUEST:
                    return cxpUseCreateRequest(params.data);
                default:
                    break;
            }
        },
        {
            onSuccess: () => {
                setTimeout(() => {
                    AppQueryClient.invalidateQueries('useNotificationsCount');
                }, 2000);
                appInsightsService.logEvent('usePostRequestType was Succesful');
            }
        }
    );
    return requestTypeMutation;
};

/**
 * Mutation used to submit shared request from unified dashboard
 */
// CSSReviewRequest does not currently return a boolean. Let's decide whether we want to use booleans or DTOs for these.
export const useShareRequest = () => {
    const mutation = useMutation((data: IShareRequest) => {
        switch (data.team) {
            case 1: // SDSG
                return sdsgUseShareRequest(data);
            case 2: // CXP
                return cxpUseShareRequest(data);
            case 3: // CSS
                return cssUseShareRequest(data);
            case 4: // Crew
                return crewUseShareRequest(data);
            default:
                break;
        }
    }, {
        onSuccess: () => {
            setTimeout(() => {
                AppQueryClient.invalidateQueries('useNotificationsCount');
                appInsightsService.logEvent('useShareRequest was Succesful');
            }, 2000);
        }
    });
    return mutation;
};

/**
 * Mutation used to update details of a request in admin dashboard
 */
export const useUpdateRequest = () => {
    const mutation = useMutation((data: IUpdateRequestDto) => {
        switch (data.requestDto.requestTeam) {
            case 1: // SDSG
                return sdsgUseUpdateRequest(data.requestDto);
            case 2: // CXP
                return cxpUseUpdateRequest(data.requestDto);
            case 3: // CSS
                return cssUseUpdateRequest(data.requestDto);
            case 4: // Crew
                return crewUseUpdateRequest(data.requestDto);
            default:
                break;
        }
    // const mutation = useMutation((data: IUpdateRequest) => {
    //     switch (data.team) {
    //         case 1: // SDSG
    //             return sdsgUseUpdateRequest(data);
    //         case 2: // CXP
    //             return cxpUseUpdateRequest(data);
    //         case 3: // CSS
    //             return cssUseUpdateRequest(data);
    //         case 4: // Crew
    //             return crewUseUpdateRequest(data);
    //         default:
    //             break;
    //     }
    }, {
        onMutate: async () => {
            await AppQueryClient.cancelQueries('requestQuery');
            await AppQueryClient.cancelQueries('listBuilder');
        },
        onSuccess: () => {
            setTimeout(() => {
                AppQueryClient.invalidateQueries('useNotificationsCount');
            }, 2000);
            appInsightsService.logEvent('useUpdateRequest was Succesful');
        },
        onError: () => {
            AppQueryClient.invalidateQueries('requestQuery');
            appInsightsService.logEvent('useUpdateRequest Failed');
        }
    });
    return mutation;
};

/**
 * Module: Admin Assign Request
 * Custom hook to assign a request */
export const useAssignRequest = () => {
    const response = useMutation(({ team, requestType, data }: {
        team: number;
        requestType: number;
        data: IAssignRequestDto;
    }) => {
        switch(team){
            case 1: // SDSG
                return sdsgUseAssignRequest(requestType, data);
            case 2: // CXP
                return cxpUseAssignRequest(data);
            case 3: // CSS
                return cssUseAssignRequest(requestType, data);
            case 4: // Crew
                return crewUseAssignRequest(requestType, data);
            default:
                break;
        }}, {
            onSuccess: () => {
                setTimeout(() => {
                    AppQueryClient.invalidateQueries('useNotificationsCount');
                }, 2000);
                appInsightsService.logEvent('useAssignRequest was Succesful');
        }
    });
    return response;
};

export const usePostAddCustomer = () => {
    const requestTypeMutation = useMutation(({subUrl, data}:{subUrl: string, data: IAddCustomerImpactDto}) => 
        {
            switch (subUrl) {
                case RouteConstants.SDSG_PROPOSAL_ADDCUSTOMERIMPACT:
                case RouteConstants.SDSG_QUESTION_ADDCUSTOMERIMPACT:
                case RouteConstants.SDSG_RFX_ADDCUSTOMERIMPACT:
                    return sdsgUsePostAddCustomer(subUrl, data);
                case RouteConstants.CXP_IRT_REQUEST_ADDCUSTOMERIMPACT:
                    return cxpUsePostAddCustomer(data);
                case RouteConstants.CSS_CSS_REQUEST_ADDCUSTOMERIMPACT:
                case RouteConstants.CSS_REVIEW_REQUEST_ADDCUSTOMERIMPACT:
                    return cssUsePostAddCustomer(subUrl, data);
                case RouteConstants.CREW_PRESALES_ADDCUSTOMERIMPACT:
                case RouteConstants.CREW_POSTSALES_ADDCUSTOMERIMPACT:
                    return crewUsePostAddCustomer(subUrl, data);
                default:
                    break;
            }
        }, {
            onSuccess: () => {
                setTimeout(() => {
                    AppQueryClient.invalidateQueries('useNotificationsCount');
                }, 2000);
                AppQueryClient.invalidateQueries('getRequestById');
                AppQueryClient.invalidateQueries('requestQuery');
                AppQueryClient.invalidateQueries('listBuilder');
                appInsightsService.logEvent('usePostAddCustomer was Succesful');
        }
    });
    return requestTypeMutation;
};

export const useAddAttachment = () => {
    const mutation = useMutation(({subUrl, data}:{subUrl: string, data: IAddAttachmentDto}) =>
    {
        switch (subUrl) {
            case RouteConstants.SDSG_PROPOSAL:
            case RouteConstants.SDSG_QUESTION:
            case RouteConstants.SDSG_RFX:
                return sdsgUseAddAttachment(subUrl, data);
            case RouteConstants.CXP_IRT_REQUEST:
                return cxpUseAddAttachment(data);
            case RouteConstants.CSS_CSS_REQUEST:
            case RouteConstants.CSS_REVIEW_REQUEST:
                return cssUseAddAttachment(data);
            case RouteConstants.CREW_PRESALES:
            case RouteConstants.CREW_POSTSALES:
                return crewUseAddAttachment(subUrl, data);
            default:
                break;
        }
    }, {
        onSuccess: () => {
            setTimeout(() => {
                AppQueryClient.invalidateQueries('useNotificationsCount');
            }, 2000);
            appInsightsService.logEvent('useAddAttachment was Succesful');
        }
    });
    return mutation;
};

// TODO - Would be good to make it so after successfully completing removal of attachment we remove it from blob storage
export const useRemoveAttachment = () => {
    const mutation = useMutation(({url, data}:{url: string, data: IAttachmentRequest}) => {
        switch (url) {
            case RouteConstants.SDSG_PROPOSAL:
            case RouteConstants.SDSG_QUESTION:
            case RouteConstants.SDSG_RFX:
                return sdsgUseRemoveAttachment(url, data.id, data.entityId, data.entityType);
            case RouteConstants.CXP_IRT_REQUEST:
                return cxpUseRemoveAttachment(data.id, data.entityId, data.entityType);
            case RouteConstants.CSS_CSS_REQUEST:
            case RouteConstants.CSS_REVIEW_REQUEST:
                return cssUseRemoveAttachment(data.id, data.entityId, data.entityType);
            case RouteConstants.CREW_PRESALES:
            case RouteConstants.CREW_POSTSALES:
                return crewUseRemoveAttachment(url, data.id, data.entityId, data.entityType);
            default:
                break;
        }
    }, {
        onSuccess: () => {
            appInsightsService.logEvent('useRemoveAttachment was Succesful');
        }
    });
    return mutation;
};

export const useUpdateAttachmentClassification = () => {
    const mutation = useMutation(
        ({url, data}:{url: string, data: IUpdateClassificationDto}) => {
            switch (url) {
                case RouteConstants.SDSG_PROPOSAL:
                case RouteConstants.SDSG_QUESTION:
                case RouteConstants.SDSG_RFX:
                    return sdsgUseUpdateAttachmentClassification(url, data);
                case RouteConstants.CXP_IRT_REQUEST:
                    return cxpUseUpdateAttachmentClassification(data);
                case RouteConstants.CSS_CSS_REQUEST:
                case RouteConstants.CSS_REVIEW_REQUEST:
                    return cssUseUpdateAttachmentClassification(data);
                case RouteConstants.CREW_PRESALES:
                case RouteConstants.CREW_POSTSALES:
                    return crewUseUpdateAttachmentClassification(url, data);
                default:
                    break;
            }
        }, {
            onSuccess: () => {
                appInsightsService.logEvent('useUpdateAttachmentClassification was Succesful');
            }
        }
    );
    return mutation;
};

export const useRemoveCustomerImpact = () => {
    const mutation = useMutation(({url, id, data}:{url: RouteConstants, id: string, data: ICustomerImpactDto}) => {
        switch (url) {
            case RouteConstants.SDSG_PROPOSAL:
            case RouteConstants.SDSG_QUESTION:
            case RouteConstants.SDSG_RFX:
                return sdsgUseRemoveCustomerImpact(url, id, data);
            case RouteConstants.CXP_IRT_REQUEST:
                return cxpUseRemoveCustomerImpact(id, data);
            case RouteConstants.CSS_CSS_REQUEST:
            case RouteConstants.CSS_REVIEW_REQUEST:
                return cssUseRemoveCustomerImpact(url, id, data);
            case RouteConstants.CREW_PRESALES:
            case RouteConstants.CREW_POSTSALES:
                return crewUseRemoveCustomerImpact(url, id, data);
            default:
                break;
        }
    }, {
        onSuccess: () => {
            AppQueryClient.invalidateQueries(StringConstants.REQUEST_QUERY);
            AppQueryClient.invalidateQueries(StringConstants.GET_REQUEST_BY_ID);
            AppQueryClient.invalidateQueries(StringConstants.LIST_BUILDER_QUERY);
        }
    });
    return mutation;
};

export const usePostCommentsHashTags = () => {
    const commentsTagsMutation = useMutation(({url, id, data}: {url:string, id: string, data: IHashTagDto[]}) => {
        switch (url) {
            case RouteConstants.SDSG_PROPOSAL:
            case RouteConstants.SDSG_QUESTION:
            case RouteConstants.SDSG_RFX:
                return sdsgUsePostCommentsHashTags(url, id, data);
            case RouteConstants.CXP_IRT_REQUEST:
                return cxpUsePostCommentsHashTags(id, data);
            case RouteConstants.CSS_CSS_REQUEST:
            case RouteConstants.CSS_REVIEW_REQUEST:
                return cssUsePostCommentsHashTags(id, data);
            case RouteConstants.CREW_PRESALES:
            case RouteConstants.CREW_POSTSALES:
                return crewUsePostCommentsHashTags(url, id, data);
            default:
                break;
        }
    }, {
        onSuccess: () => {
            // Query Invalidations
            appInsightsService.logEvent('usePostCommentsHashTags was Succesful');
        }
    });
    return commentsTagsMutation;
};